// extracted by mini-css-extract-plugin
export default {"folderDropdown":"customDocs_folderDropdown__DlVxb","titleDropdown":"customDocs_titleDropdown__AEYsC"};